import React, { useEffect } from 'react'
import StudentInstruction from '../../Components/StudentInstruction'
import { MICROPHONE_STATES } from '../HardwareChecks';
import PointingArrow from './PointingArrow';
import { isChromeDesktop, isEdgeDesktop, isFirefoxDesktop, isSafariDesktop, isSafariMobile } from '../../functions/browserChecks';
import cx from 'classnames'
import RaiseHand from '../../Components/PreCheckIllustrations/RaiseHand';
export default function OtherBrowserMicrophonePermissionPrompt({ speechProps, setPermissionState, raiseYourHand,  readyToPrompt }) {

    useEffect(() => {
        if(readyToPrompt){
            speechProps.initializeRecorderIfNeeded(handleDenied, handleAllowed);
        }

    }, [readyToPrompt])

    const handleAllowed = () => {
        console.log("User allowed microphone access prompt")
        setPermissionState(MICROPHONE_STATES.granted)
    }

    const handleDenied = (error) => {
        console.log("User manually declined microphone access prompt", error)
        setPermissionState(MICROPHONE_STATES.denied)
    }

    const arrowClasses = cx({
        '__chrome': isChromeDesktop(),
        '__firefox': isFirefoxDesktop(),
        '__safari': isSafariDesktop(),
        '__edge': isEdgeDesktop(),
        '__mobile': isSafariMobile()
    })

    if(!readyToPrompt) return null

    return (
        <div>
            <StudentInstruction>
                <PointingArrow pointingDirection={'left'} classNameProp={arrowClasses}/>
                {raiseYourHand && <RaiseHand/>}
            </StudentInstruction>
        </div>
    )
}
